// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylus/components/_avatars.styl
// module id = 95
// module chunks = 0